// Keep the existing surname-first order; omit empty name parts and their separator.
export function formatPersonName(lastName, firstName) {
  return [lastName, firstName].map(part => (part ?? "").trim()).filter(Boolean).join(", ");
}

// Documents and customer selectors display the organization itself, never its contact.
export function personDisplayName(person) {
  return person?.Typ === "ORGANIZATION" ? person.Organisationsname || "" : formatPersonName(person?.Name, person?.Vorname);
}
